export const IndentConfig = {
  max: 100,
  min: 0,
  more: 1,
  less: -1,
} as const;
